import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: relative;
  font-family: 'Lato';
  font-weight: 400;

  .brand-container {
    background: linear-gradient(to right, rgba(74, 74, 74, 1), rgba(0, 0, 0, 1));
    position: fixed;
    bottom: 0;
    padding: 45px 35px 41px 35px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
  }

  .circle-loader {
    width: 22px;
    height: 22px;
    border: solid 2px #008cff;
    margin-bottom: 40px;
    border-radius: 50%;
    border-bottom-color: transparent;
    transition: all 0.5s ease-in;
    animation: ${rotate} 1s linear infinite;
  }

  .loader-section-message {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .loading-message {
    padding: 0px 80px;
    text-align: center;
    font-family: 'Lato';
    font-weight: 400;
    font-size: 14px;
  }

  @media only screen and (max-width: 400px) {
    .brand-container {
      gap: 8px;
      padding: 24px;
    }
  }
`;

export const BrandCompanyLogo = styled.img`
  width: 80px;
  height: 48px;
  padding: 8px;
  border-radius: 8px;
  border: 0.942px solid #008CFF;
  background: #FFF;
  object-fit: contain;
`;